/**
 * Creates an object composed of the own enumerable properties of object that predicate doesn't return truthy for.
 * The predicate is invoked with two arguments: (value, key).
 * If predicate is a string, it omits the property with that key name.
 *
 * @param object - The source object
 * @param predicate - The function invoked per property or a string key to omit
 * @returns Returns the new object
 */
export function omitBy<T extends object>(
  object: T,
  predicate: ((value: T[keyof T], key: keyof T) => boolean) | string,
): Partial<T> {
  const result = {} as Partial<T>

  for (const key in object) {
    if (Object.hasOwn(object, key)) {
      const value = object[key]

      // If predicate is a string, check if key matches
      if (typeof predicate === 'string') {
        // eslint-disable-next-line max-depth
        if (key !== predicate) {
          result[key] = value
        }
      } else if (typeof predicate === 'function') {
        // If predicate is a function, use it
        // eslint-disable-next-line max-depth
        if (!predicate(value, key)) {
          result[key] = value
        }
      }
    }
  }

  return result
}
